/*eslint-disable */
import React, { useEffect, useState } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik, FieldArray } from "formik";
import * as yup from "yup";
import moment from "moment";
import { useHistory } from "react-router-dom";
import {
  Form as FormUi,
  Container,
  TextArea,
  Button,
  Input,
  Segment,
  Dropdown,
  Divider,
  Icon,
  Search,
} from "semantic-ui-react";
import "react-datepicker/dist/react-datepicker.css";
// import InsertJobOrders from "./insertOrder";
// import InsertDocument from "./documentdetail";
import { DateData } from "../dynamicComponent/datepick";
import { DateBooking } from "../dynamicComponent/datepickBooking";
import { MyNormalInput, MyTextArea, MyTempInput } from "../dynamicComponent/myInputs";
import ContainerSize from "../dynamicComponent/containerSize";
import ShippingLine from "../dynamicComponent/shippingLine";
import CHAInput from "../dynamicComponent/chaInput";
import ShowAddress from "../dynamicComponent/showAddress";
import ShowRouteInfo from "../dynamicComponent/showRouteInfo";
import BillingPartyWithCreate from "../dynamicComponent/billingPartyWithCreate";
import MyServiceType from "../dynamicComponent/myServiceType";
import LoadType from "../dynamicComponent/loadType";
import MyContainerType from "../dynamicComponent/myContainerType";
import MyContainerSize from "../dynamicComponent/myContainerSize";

import {
  createShipmentDispatcher,
  deleteAllOrderDispatcher,
} from "../../redux/actions/shipmentAction";
import { connect } from "react-redux";
import SearchDropdown from "./searchDropdown";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import ReadAxios from "../axiosComponent/read";
import CreatAxios from "../axiosComponent/create";
import UpdateAxios from "../axiosComponent/update";
import { translate } from "react-i18next";
import ConsigneeWithCreate from "../dynamicComponent/consigneeWithCreate";
import ConsignorWithCreate from "../dynamicComponent/consignorWithCreate";
import ModalCreateConsignee from "../createShipmentComponent/modalCreateConsignee";
import ModalCreateConsignor from "../createShipmentComponent/modalCreateConsigner";
import ModalCreateBillingParty from "../createShipmentComponent/modalCreateBillingParty";
import BranchDropdown from "../dropdowns/branchDropdown";
import YardDropdown from "../dropdowns/yardDropdown";
import BillingPartyBranch from "../dropdowns/billingPartyBranch";

// TODO: make call from redux
import { min, isEmpty } from "lodash";
import MandatoryMark from "../common/mandatorymark";
// import ModalDiscardOrder from "./orderDiscardConfirmation";
import allAxiosCommonRequest from "../axiosComponent/allAxiosCommonRequest";
import allAxiosCommonTA from "../axiosComponent/allAxiosCommonTA";
import cogoToast from "cogo-toast";
import ModalCreateRoute from "../createShipmentComponent/modalCreateRoute";
import UploadDO from "../dynamicComponent/uploadDO";
import { DATE_FORMATS, FEATURES } from '../../utils/constant'
import MyUser from "../apiInputs/myUser";
import { TOAST_MESSAGES } from "../../utils/toastMsgConstant";

const insertBookingRequestImportEdit = ({
  values,
  vehicleTypeMaster,
  setFieldValue,
  touched,
  errors,
  handleSubmit,
  shipment,
  bookingRequestObj,
  routeCodes,
  routeNames,
  mode,
  isSubmitting,
  deleteAllOrderDispatcher,
  t,
  props,
}) => {
  const [deleteModal, setdeleteModal] = useState(false);
  // const [movementType, setmovementType] = useState("primary");
  const [disable, setmovementTypedisable] = useState(false);
  const [products, setproducts] = useState([]);
  const [vehicles, setvehicletype] = useState([]);
  const [shipmentdata, setShipment] = useState({});

  useEffect(() => {
    if (values.booking_containers) {
      let addition = 0
      let tempArray = []
      values.booking_containers.map((item, ind) => (
        tempArray.push(item.no_of_containers)
      ))
      for (var i in tempArray) {
        addition += tempArray[i];
      }
      setFieldValue(`total_number_of_containers`, parseInt(addition))

    }
  }, [values.booking_containers])


  useEffect(() => {
    setPreselectedValue();
  }, []);

  const setPreselectedValue = () => {
    if (mode == "edit" || mode == "view") {
      if (bookingRequestObj.route)
        setRouteAddressState(bookingRequestObj.route);

      if (bookingRequestObj.deliveryBooking) {
        let temp = [];
        for (let index = 0; index < bookingRequestObj.deliveryBooking.length; index++) {
          const element = bookingRequestObj.deliveryBooking[index];
          temp.push(element)
        }

        setFieldValue("deliveries", temp)
      }
      if (bookingRequestObj.booking_containers) {
        let temp = [];
        for (let index = 0; index < bookingRequestObj.booking_containers.length; index++) {
          const element = bookingRequestObj.booking_containers[index];
          temp.push(element)
        }

        setFieldValue("booking_containers", temp)
      }
    }
  };

  const [routeAddressState, setRouteAddressState] = useState("");
  const [masterState, setMasterState] = useState("");
  const getMasterBranchSelected = (branchCode, branchData) => {
    const addedMasterBranchObject = branchData.find(
      (data) => data.branchId === branchCode
    );
    //setMasterState(addedMasterBranchObject.stateId);
  };

  const [consignorAddressState, setConsignorAddressState] = useState("");
  const [consigneeAddressState, setConsigneeAddressState] = useState("");
  /* const setBillingBranch = (billingBranch) => {
    setBillingBranchState(billingBranch);
  }; */

  const [billingBranchState, setBillingBranchState] = useState("");
  const [billingPartyBranchList, setBillingPartyBranchList] = useState("");
  const setBillingBranch = (billingBranch) => {
    setBillingBranchState(billingBranch);
  };

  const [billingPartyBranch, setBillingPartyBranch] = useState("");
  const setBillingPartyBranchSelected = (
    billingBranchCode,
    billingBranchData
  ) => {
    const addedBillingBranchObject = billingBranchData
      .find
      //(data) => data.branchCode === branchCode
      ();
    //setBillingBranchState(addedBillingBranchObject.stateId);
  };

  const [yardState, setYardState] = useState("");
  const getYardSelected = () => { };

  const history = useHistory();
  const routeBackToBookingAggrid = () => {
    history.push("/booking-request");
  };

  const onAddcontainer = (/* e, field,*/event, values, name, setValues) => {
    event.preventDefault();
    event.stopPropagation();

    // update dynamic form
    const containerDetails = [...values.booking_containers];
    const previousNumber = values.numberOfContainerCount;

    values.numberOfContainerCount += 1;

    const numberOfContainerCount = values.numberOfContainerCount;

    if (previousNumber < numberOfContainerCount) {
      for (let i = previousNumber; i < numberOfContainerCount; i++) {
        let containerAddList = getContainerArray(values);
        containerDetails.push(containerAddList);
      }
    } else {
      for (let i = previousNumber; i >= numberOfContainerCount; i--) {
        containerDetails.splice(i, 1);
      }
    }

    setValues(name, containerDetails);
  }

  const getContainerArray = (values) => {
    return {
      no_of_containers: 1,

      container_size: "FT20",

      container_size_placeholder: "20 Feet",

      container_type_id: "",

      container_type: "",

    }
  }

  const onChangeContainerRemove = (/* e, field,*/ values, name, setValues, index) => {
    // update dynamic form
    const containerDetails = [...values.booking_containers];
    containerDetails.splice(index, 1);

    setValues(name, containerDetails);
  }

  const onChangeDeliveries = (/* e, field,*/event, values, name, setValues) => {
    event.preventDefault();
    event.stopPropagation();

    // update dynamic form
    const deliveries = [...values.deliveries];
    const previousNumber = values.numberOfDeliveries;

    values.numberOfDeliveries += 1;

    const numberOfDeliveries = values.numberOfDeliveries;

    if (previousNumber < numberOfDeliveries) {
      for (let i = previousNumber; i < numberOfDeliveries; i++) {
        let deliveryAddList = getDeliveryArray(values);
        deliveries.push(deliveryAddList);
      }
    } else {
      for (let i = previousNumber; i >= numberOfDeliveries; i--) {
        deliveries.splice(i, 1);
      }
    }

    setValues(name, deliveries);
  }

  const getDeliveryArray = (values) => {
    return {
      requested_pickup_date: values?.deliveries?.[0]?.requested_pickup_date ?
        moment(values.deliveries[0].requested_pickup_date, DATE_FORMATS.YYYYMMDD_HHMM)
        : props.requested_pickup_date,

      requested_delivery_date: values?.deliveries?.[0]?.requested_delivery_date ?
        moment(values.deliveries[0].requested_delivery_date, DATE_FORMATS.YYYYMMDD_HHMM)
        : "",
      billing_party_id: values?.deliveries?.[0]?.billing_party_id ?
        values.deliveries[0].billing_party_id : null,

      billing_party_placeholder: values?.deliveries?.[0]?.billing_party_placeholder ?
        values.deliveries[0].billing_party_placeholder : "",

      billing_party_branch_id: values?.deliveries?.[0]?.billing_party_branch_id ?
        values.deliveries[0].billing_party_branch_id : null,

      billing_party_branch_placeholder: values?.deliveries?.[0]?.billing_party_branch_placeholder ?
        values.deliveries[0].billing_party_branch_placeholder : "",

      consignor_code: values?.deliveries?.[0]?.consignor_code ?
        values.deliveries[0].consignor_code : "",

      consignor_placeholder: values?.deliveries?.[0]?.consignor_placeholder ?
        values.deliveries[0].consignor_placeholder : "",

      consignee_code: values?.deliveries?.[0]?.consignee_code ?
        values.deliveries[0].consignee_code : "",

      consignee_placeholder: values?.deliveries?.[0].consignee_placeholder ?
        values.deliveries[0].consignee_placeholder : "",

      consignorRaw: values?.deliveries?.[0]?.consignorRaw ?
        values.deliveries[0].consignorRaw : "",

      consigneeRaw: values?.deliveries?.[0]?.consigneeRaw ?
        values.deliveries[0].consigneeRaw : "",

      shipping_line_id: values?.deliveries?.[0]?.shipping_line_id ?
        values.deliveries[0].shipping_line_id : "",

      shipping_line_placeholder: values?.deliveries?.[0]?.shipping_line_placeholder ?
        values.deliveries[0].shipping_line_placeholder : "",

      CHA_id: values?.deliveries?.[0]?.CHA_id ?
        values.deliveries[0].CHA_id : "",

      cha_placeholder: values?.deliveries?.[0]?.cha_placeholder ?
        values.deliveries[0].cha_placeholder : "",

      yard_id: values?.deliveries?.[0]?.yard_id ?
        values.deliveries[0].yard_id : "",

      yard_placeholder: values?.deliveries?.[0]?.yard_placeholder ?
        values.deliveries[0].yard_placeholder : "",

      booking_invoices: [
        {
          BoE_no: values?.deliveries?.[0]?.booking_invoices?.[0]?.BoE_no ?
            values.deliveries[0].booking_invoices[0].BoE_no : "",

          BoE_date: values?.deliveries?.[0]?.booking_invoices?.[0]?.BoE_date ?
            values.deliveries[0].booking_invoices[0].BoE_date : "",

        }
      ]
    }
  }

  const onChangeDeliveriesRemove = (/* e, field,*/ values, name, setValues, index) => {
    // update dynamic form
    const deliveries = [...values.deliveries];
    deliveries.splice(index, 1);

    setValues(name, deliveries);
  }

  return (
    <div>
      <Formiker>
        {/* <AddTitleBar Title="Create Rate Engine" LinkName="/rate-engine" /> */}
        <div>
          <>
            <FieldArray name="ShipmentDetails">

              <div key="ShipmentDetails" className="list-group list-group-flush">
                <div className="list-group-item padding-0-imp mt-4">
                  <div>
                    <h5 className="card-title">Shipment Details</h5>
                  </div>
                  <>
                    <div className="form-row display-flex-center-justify-spacebtwn">
                      <div className="form-group col-4">
                        <div>
                          <label className="required-form-element">
                            {t("shipment_form.route.title") || "Route"}
                          </label>
                        </div>
                        <div className="display-flex-center">
                          <div className="master-with-search">
                            <SearchDropdown
                              disabled={mode == "view" ? true : false}
                              setField={(name, value) => {
                                setRouteAddressState(value.raw ? value.raw : "");
                                // setFieldValue("vehicle_number", value.raw ? value.raw.vehicleNumber : value)
                                setFieldValue(
                                  "route",
                                  value.raw ? value.raw.routeCode : ""
                                );
                                setFieldValue(
                                  "deliveries[0].requested_delivery_date",
                                  //values.requested_pickup_date
                                  value.raw ?
                                    moment(values.deliveries[0].requested_pickup_date).add(value.raw.budgetedRouteTat,
                                      'hours').format(DATE_FORMATS.YYYYMMDD_HHMM) : ""
                                );
                              }}
                              placeholder={values.route_placeholder}
                              masterRoute="routeMaster"
                              masterRouteKey="routeMasterId"
                              masterRouteName="routeName"
                              className="ui placeholder-black"
                              fieldName="route"
                              blurMessage={"Please confirm route."}
                            />
                          </div>
                          <div>
                            <ModalCreateRoute />
                          </div>
                        </div>
                        {/* {errors.route && touched.route ? (
                          <div>{"Route is required."}</div>
                        ) : null} */}
                      </div>
                      <div className="form-group col-3"></div>
                      <div className="form-group col-4">
                        <div>
                          <label className="do-group-container-label">
                            <div className="ui action display-flex-center-justify-spacebtwn">
                              <div className="do-group-container">
                                {"CRO Number"}
                              </div>
                              <div className="do-group-container-big">
                                {"CRO Expiry Date"}
                              </div>
                              {mode == "edit" || mode == "view" ?
                                <div className="do-group-container">
                                  {"CRO Upload"}
                                </div>
                                : null}
                            </div>
                          </label>
                        </div>
                        <div className="adjust-width-cell">
                          <Fieldmik disabled={mode == "view" ? true : false} component={UploadDO} mode={mode} bookingRequestObj={bookingRequestObj} values={values} />
                        </div>
                      </div>
                      <div className="form-group col-1"></div>
                    </div>
                    <div className="form-row display-flex-center-justify-spacebtwn">
                      <div className="form-group col-4">
                        <Fieldmik
                          disabled={mode == "view" ? true : false}
                          mode={mode}
                          component={ShowRouteInfo} id={values.route} values={values}
                          bookingDeliveryDateName={`deliveries[0].requested_delivery_date`}
                          requested_pickup_date_booking={values.deliveries[0].requested_pickup_date}
                          requested_delivery_date_booking={values.deliveries[0].requested_delivery_date}
                          routeAddressState={routeAddressState} name="show_route_info" />
                      </div>
                      <div className="form-group col-3"></div>
                      <div className="form-group col-4">
                      </div>
                      <div className="form-group col-1"></div>
                    </div>



                    <div className="form-row display-flex-center-justify-spacebtwn">
                      {/* <div className="form-group col-4">
                        <div>
                          <label className="required-form-element">{"Service Type"}</label>
                        </div>
                        <div className="adjust-width-cell">
                          <Fieldmik
                            disabled={mode == "view" ? true : false}
                            placeholder={values.service_type_placeholder}
                            component={MyServiceType}
                            name="service_type_id"
                          />
                        </div>
                      </div>
                      <div className="form-group col-3"></div> */}
                      <div className="form-group col-4">
                        <div>
                          <label className="required-form-element">{"Load Type"}</label>
                        </div>
                        <div className="adjust-width-cell">
                          <Fieldmik
                            disabled={mode == "view" ? true : false}
                            placeholder={values.load_type_placeholder}
                            component={LoadType}
                            name="load_type"
                            default={bookingRequestObj.load_type || "Dry"} />
                        </div>
                      </div>
                      <div className="form-group col-3"></div>
                      <div className="form-group col-4">
                        <div>
                          <label>{t("shipment_form.remarks.title") || "Remarks"}</label>
                        </div>
                        <div className="adjust-width-cell">
                          <Fieldmik
                            disabled={mode == "view" ? true : false}
                            placeholder={values.remarks}
                            component={MyTextArea}
                            name="remarks"
                          />
                        </div>
                      </div>
                      <div className="form-group col-1"></div>
                    </div>
                  </>
                </div>
              </div>
            </FieldArray>


            <div className="form-row text-center border-top-0 display-flex-center-justify-spacebtwn mt-4">
              <div className="form-group col-4">
                <div className="text-left">
                  <label className="required-form-element">
                    {"Total No. of Containers "}
                  </label>
                </div>
                <div className="adjust-width-cell">
                  <Fieldmik disabled={mode == "view" ? true : false} component={MyNormalInput} type="number" name="total_number_of_containers" readOnly />
                </div>
              </div>
              {mode != "view" ?
                <button className="ui mini basic icon primary button" onClick={(e) => { onAddcontainer(e, values, 'booking_containers', setFieldValue) }} >
                  <i aria-hidden="true" class="plus icon"></i>
                  Add Container
                </button>
                : null}
            </div>
            <FieldArray name="container_details">

              {() => (values.booking_containers.map((ContainerObj, i) => {

                return (
                  <div key={i} className="list-group list-group-flush">
                    <div className="list-group-item padding-0-imp">
                      <div className="display-flex-center-justify-spacebtwn mt-2 mb-2">
                        <h5 className="card-title">Container Details {i + 1}</h5>
                        {(i >= 1 && mode != "view") ?
                          <button className="ui red mini basic icon button" onClick={() => { onChangeContainerRemove(values, 'booking_containers', setFieldValue, i) }} >
                            <i aria-hidden="true" class="trash icon"></i>
                            Delete container
                          </button>
                          : null
                        }
                      </div>

                      <>
                        <div className="form-row display-flex-center-justify-spacebtwn">
                          <div className="form-group col-3">
                            <div>
                              <label className="required-form-element">
                                {"Container Size"}
                              </label>
                            </div>
                            <div className="adjust-width-cell">
                              <Fieldmik
                                disabled={mode == "view" ? true : false}
                                component={MyContainerSize}
                                name={`booking_containers[${i}].container_size`}
                                placeholder={
                                  mode == "view" || mode == "edit" ? values.booking_containers[i].container_size : values.booking_containers[i].container_size_placeholder
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group col-1"></div>
                          <div className="form-group col-3">
                            <div>
                              <label className="required-form-element">
                                {"Container Type"}
                              </label>
                            </div>
                            <div className="adjust-width-cell">
                              <Fieldmik
                                disabled={mode == "view" ? true : false}
                                component={ContainerSize}
                                name={`booking_containers[${i}].container_type_id`}
                                placeholder={
                                  mode == "view" || mode == "edit" ? values.booking_containers[i].container_type : values.booking_containers[i].container_type
                                }
                              />
                            </div>
                          </div>
                          <div className="form-group col-1"></div>
                          <div className="form-group col-2">
                            <div>
                              <label className="required-form-element">
                                {"No. of Containers"}
                              </label>
                            </div>
                            <div className="adjust-width-cell">
                              <Input
                                disabled={false}
                                type="number"
                                name={`booking_containers[${i}].no_of_containers`}
                                onBlur={() => {
                                  if (values.booking_containers) {
                                    let addition = 0
                                    let tempArray = []
                                    values.booking_containers.map((item, ind) => (
                                      tempArray.push(item.no_of_containers)
                                    ))
                                    for (var i in tempArray) {
                                      addition += tempArray[i];
                                    }
                                    setFieldValue(`total_number_of_containers`, parseInt(addition))
                                  }
                                }
                                }
                                onChange={(name, data) => {
                                  setFieldValue(`booking_containers[${i}].no_of_containers`, parseInt(data.value))
                                }}
                                value={values.booking_containers[i].no_of_containers}
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    </div>
                  </div>
                );
              }))}

            </FieldArray>

            <FieldArray name="OrderDetails">

              <div key="OrderDetails" className="list-group list-group-flush">
                <div className="list-group-item padding-0-imp mt-4">
                  <div>
                    <h5 className="card-title">Order Details</h5>
                  </div>
                  <>
                    <div className="form-row display-flex-center-justify-spacebtwn">
                      <div className="form-group col-4">
                        <div>
                          <label>
                            {t("shipment_form.weight.title") || "Weight (in kgs)"}
                          </label>
                        </div>
                        <div className="adjust-width-cell">
                          <Fieldmik disabled={mode == "view" ? true : false} component={MyNormalInput} name="weight" />
                        </div>
                      </div>
                      <div className="form-group col-3"></div>
                      <div className="form-group col-4">
                      </div>
                      <div className="form-group col-1"></div>
                    </div>


                    {values.load_type != 4 ? (
                      <div className="form-row display-flex-center-justify-spacebtwn">
                        <div className="form-group col-4">
                          <div>
                            <label>
                              {t("shipment_form.temp_min.title") ||
                                "Temperature Minimum"}
                            </label>
                          </div>
                          <div className="adjust-width-cell">
                            <Fieldmik
                              disabled={mode == "view" ? true : false}
                              component={MyTempInput} className="placeholder-black" name="temp_min"
                              placeholder={values.temp_min} icon="thermometer quarter" iconPosition="left" style={{
                                paddingTop: "5.5px"
                              }} />
                          </div>
                        </div>
                        <div className="form-group col-3"></div>
                        <div className="form-group col-4">
                          <div>
                            <label>
                              {t("shipment_form.temp_max.title") ||
                                "Temperature Maximum"}
                            </label>
                          </div>
                          <div className="adjust-width-cell">
                            <Fieldmik
                              disabled={mode == "view" ? true : false}
                              component={MyTempInput} className="placeholder-black" name="temp_max"
                              placeholder={values.temp_max} icon="thermometer quarter" iconPosition="left" style={{
                                paddingTop: "5.5px"
                              }} />
                          </div>
                        </div>
                        <div className="form-group col-1"></div>
                      </div>)
                      :
                      null
                    }
                  </>
                </div>
              </div>
            </FieldArray>


            <>
              <div className="text-center border-top-0 display-flex-center-justify-spacebtwn mt-4">
                <div>
                  <h4>Delivery Details</h4>
                </div>
                {/* <button className="ui mini basic icon primary button" onClick={(e) => { onChangeDeliveries(e, values, 'deliveries', setFieldValue) }} >
                  <i aria-hidden="true" class="plus icon"></i>
                  New Delivery
                </button> */}
              </div>
              <br />
              <FieldArray name="deliveries">
                {() => (values.deliveries.map((deliveryObj, i) => {
                  const ticketErrors = errors.deliveries?.length && errors.deliveries[i] || {};
                  const ticketTouched = touched.deliveries?.length && touched.deliveries[i] || {};
                  return (
                    <div key={i} className="list-group list-group-flush">
                      <div className="list-group-item padding-0-imp">
                        <div className="display-flex-center-justify-spacebtwn mt-2 mb-2">
                          <h5 className="card-title">Delivery Details {i + 1}</h5>
                          {(i >= 1 && mode != "view") ?
                            <button className="ui red mini basic icon button" onClick={() => { onChangeDeliveriesRemove(values, 'deliveries', setFieldValue, i) }} >
                              <i aria-hidden="true" class="trash icon"></i>
                              Delivery
                            </button>
                            : null
                          }
                        </div>
                        <>
                          <div className="form-row display-flex-center-justify-spacebtwn">
                            <div className="form-group col-4">
                              <div>
                                <label className="required-form-element">
                                  {FEATURES.bookingInvoiceDetails ?
                                    <>
                                      Requested Stuffing Date
                                    </>
                                    :
                                    <>
                                      {t("shipment_form.pick_up_date.title") ||
                                        "Requested Pickup Date"}
                                    </>
                                  }
                                </label>
                              </div>
                              <div>
                                <DateBooking
                                  disabled={mode == "view" ? true : false}
                                  name={`deliveries[${i}].requested_pickup_date`}
                                  tname={`deliveries[${i}].requested_pickup_date`}
                                  autoComplete="off"
                                  showTimeSelect
                                  timeFormat="hh:mm"
                                  popperClassName="dateTime"
                                  dateFormat="dd-MM-yyyy HH:mm"
                                  timeIntervals={5}
                                  setDeliveryDate={`deliveries[${i}].requested_delivery_date`}
                                  values={values}
                                  customInput={
                                    <Input
                                      icon="time"
                                      className="poupDate"
                                      iconPosition="left"
                                    />
                                  }
                                  error={
                                    touched.requested_pickup_date &&
                                      errors.requested_pickup_date
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </div>
                            <div className="form-group col-3"></div>
                            <div className="form-group col-4">
                              <div>
                                <label className="required-form-element">
                                  {t("shipment_form.delivery_up_date.title") ||
                                    "Expected Delivery Date"}
                                </label>
                              </div>
                              <div>
                                <DateData
                                  disabled={mode == "view" ? true : false}
                                  name={`deliveries[${i}].requested_delivery_date`}
                                  tname={`deliveries[${i}].requested_delivery_date`}
                                  autoComplete="off"
                                  showTimeSelect
                                  timeFormat={DATE_FORMATS.hhmm}
                                  popperClassName="dateTime"
                                  dateFormat={DATE_FORMATS.ddMMyyy_HHmm}
                                  timeIntervals={5}
                                  customInput={
                                    <Input
                                      icon="time"
                                      className="poupDate"
                                      iconPosition="left"
                                    />
                                  }
                                />
                                {errors?.deliveries?.[i]?.requested_delivery_date ? (
                                  <div className="w3-small w3-text-red">
                                    {"Delivery Date should be greater than Pickup Date."}
                                  </div>
                                ) : null}

                              </div>
                            </div>
                            <div className="form-group col-1"></div>
                          </div>
                          <div className="form-row display-flex-center-justify-spacebtwn">
                            <div className="form-group col-4">
                              {FEATURES.bookingBillingParty ?
                                <label className="">
                                  {t("shipment_form.billing_party.title") ||
                                    "Billing Party"}
                                </label>
                                :
                                <label className="required-form-element">
                                  {t("shipment_form.billing_party.title") ||
                                    "Billing Party"}
                                </label>
                              }
                              <Fieldmik
                                disabled={mode == "view" ? true : false}
                                //placeholder={values.billing_party_placeholder}
                                placeholder={
                                  values.deliveries[i].billing_party_placeholder
                                }
                                component={BillingPartyWithCreate}
                                placeholderName={`deliveries[${i}].billing_party_placeholder`}
                                name={`deliveries[${i}].billing_party_id`}
                                dataId="billingBranchState"
                                setBillingBranch={setBillingBranch}
                                error={
                                  ticketErrors.billing_party_id && ticketTouched.billing_party_id ? true : false
                                }
                              />
                              {ticketErrors?.billing_party_id && ticketTouched?.billing_party_id ? (
                                <div className="w3-small w3-text-red">
                                  {"Please enter/select Billing Party"}
                                </div>
                              ) : null}
                            </div>
                            <div className="form-group col-3"></div>
                            <div className="form-group col-4">
                              <label>{"Billing Party Branch"}</label>
                              <Fieldmik
                                disabled={mode == "view" ? true : false}
                                style={{ width: "100%" }}
                                component={BillingPartyBranch}
                                name={`deliveries[${i}].billing_party_branch_id`}
                                placeholderName={`deliveries[${i}].billing_party_branch_placeholder`}
                                placeholder={
                                  values.deliveries[i].billing_party_branch_placeholder
                                }
                                id={values.deliveries[i].billing_party_id}
                                billingBranchState={billingBranchState}
                                billingPartyBranchList={billingPartyBranchList}
                                setBillingPartyBranchSelected={setBillingPartyBranchSelected}
                              />
                            </div>
                            <div className="form-group col-1"></div>
                          </div>

                          <div className="form-row display-flex-center-justify-spacebtwn">
                            <div className="form-group col-4">
                              {FEATURES.bookingConsignorCodeDeliveryLoc ?
                                <label className="">
                                  Port terminal
                                </label>
                                :
                                <label className="required-form-element">
                                  Port terminal
                                </label>
                              }
                              <Fieldmik
                                disabled={mode == "view" ? true : false}
                                placeholder={
                                  values.deliveries[i].consignor_placeholder
                                }
                                component={ConsignorWithCreate}
                                name={`deliveries[${i}].consignor_code`}
                                consignorRaw={`deliveries[${i}].consignorRaw`}
                                consignor_placeholder={`deliveries[${i}].consignor_placeholder`}
                                setRaw="consignorRaw"
                                //fillAddressState={setConsignorAddressState}
                                error={
                                  touched.consignor && errors.consignor ? true : false
                                }
                              />
                            </div>
                            <div className="form-group col-3"></div>
                            <div className="form-group col-4">
                              {FEATURES.bookingConsignorCodeDeliveryLoc ?
                                <label className="">
                                  Delivery location
                                </label>
                                :
                                <label className="required-form-element">
                                  Delivery location
                                </label>
                              }
                              <Fieldmik
                                disabled={mode == "view" ? true : false}
                                placeholder={
                                  values.deliveries[i].consignee_placeholder
                                }
                                component={ConsigneeWithCreate}
                                name={`deliveries[${i}].consignee_code`}
                                consigneeRaw={`deliveries[${i}].consigneeRaw`}
                                consignee_placeholder={`deliveries[${i}].consignee_placeholder`}
                                setRaw="consigneeRaw"
                                //fillAddressState={setConsigneeAddressState}
                                error={
                                  touched.consignee && errors.consignee ? true : false
                                }
                              />
                            </div>
                            <div className="form-group col-1"></div>
                          </div>

                          <div className="form-row display-flex-center-justify-spacebtwn">
                            <div className="form-group col-4">
                              <Fieldmik
                                disabled={mode == "view" ? true : false}
                                component={ShowAddress}
                                id={`values.deliveries[${i}].consignor_code`}
                                setAddressState={values.deliveries[i].consignorRaw}//{consignorAddressState}
                                name={`deliveries[${i}].consignorRaw`}
                                data={`values.deliveries[${i}].consignorRaw`}
                              />
                            </div>
                            <div className="form-group col-3"></div>
                            <div className="form-group col-4">
                              <Fieldmik
                                disabled={mode == "view" ? true : false}
                                component={ShowAddress}
                                id={`values.deliveries[${i}].consignee_code`}
                                name={`deliveries[${i}].consigneeRaw`}
                                setAddressState={values.deliveries[i].consigneeRaw}//{consigneeAddressState}
                                data={`values.deliveries[${i}].consigneeRaw`}
                              />
                            </div>
                            <div className="form-group col-1"></div>
                          </div>

                          <div className="form-row display-flex-center-justify-spacebtwn">
                            <div className="form-group col-4">
                              <div>
                                <label className="required-form-element">{"Yard"}</label>
                              </div>
                              <div>
                                <Fieldmik
                                  disabled={mode == "view" ? true : false}
                                  style={{ width: "100%" }}
                                  component={YardDropdown}
                                  name={`deliveries[${i}].yard_id`}
                                  value={values.deliveries[i].yard_id}
                                  placeholderName={`deliveries[${i}].yard_placeholder`}
                                  getYardSelected={getYardSelected}
                                />
                              </div>
                            </div>
                            <div className="form-group col-3"></div>
                            <div className="form-group col-4">
                              <div>
                                <label>{"Shipping Line"}</label>
                              </div>
                              <div>
                                <Fieldmik
                                  disabled={mode == "view" ? true : false}
                                  component={ShippingLine}
                                  name={`deliveries[${i}].shipping_line_id`}
                                  placeholder={
                                    values.deliveries[i].shipping_line_placeholder
                                  }
                                  placeholderName={`deliveries[${i}].shipping_line_placeholder`}
                                />
                              </div>
                            </div>
                            <div className="form-group col-1"></div>
                          </div>

                          <div className="form-row display-flex-center-justify-spacebtwn">
                            <div className="form-group col-4">
                              <div>
                                <label className="required-form-element">{"CHA"}</label>
                              </div>
                              <div>
                                <Fieldmik
                                  disabled={mode == "view" ? true : false}
                                  component={CHAInput}
                                  name={`deliveries[${i}].CHA_id`}
                                  placeholder={
                                    values.deliveries[i].cha_placeholder
                                  }
                                  placeholderName={`deliveries[${i}].cha_placeholder`}
                                />
                              </div>
                            </div>
                            <div className="form-group col-3"></div>
                            <div className="form-group col-4">
                              <div>
                                <label className="required-form-element">{"Service Type"}</label>
                              </div>
                              <div className="adjust-width-cell">
                                <Fieldmik
                                  disabled={mode == "view" ? true : false}
                                  placeholder={values.service_type_placeholder}
                                  component={MyServiceType}
                                  name="service_type_id"
                                />
                              </div>
                            </div>
                            {/* <div className="form-group col-3"></div> */}
                            <div className="form-group col-1"></div>
                          </div>
                          <div className="form-row display-flex-center-justify-spacebtwn">
                          <div className="form-group col-4">
                                  <label className="labelName mt-2">
                                    {FEATURES.brokerInsteadOfSalesPerson ? (t("broker.title") || "Broker") : (t("sales_person.title") || "Sales Person")}{" "}
                                  </label>
                                  
                                  <Fieldmik
                                  disabled={mode == "view" ? true : false}
                                  placeholder= {FEATURES.brokerInsteadOfSalesPerson ? (t("broker.placeholder") || "Broker") : (t("sales_person.placeholder") || "Select Sales Person")}
                                  component={MyUser}
                                  name={`deliveries[${i}].sales_person_id`}
                                  roleValidation={true}
                                  roleName={FEATURES.brokerInsteadOfSalesPerson? "broker" : "sales"}
                                  userNumber={`deliveries[${i}].sales_person_number`}
                                  userEmail={`deliveries[${i}].sales_person_email`}
                                  value={values.deliveries[i].sales_person_id}
                                />
                                  
                                  {values.deliveries[i].sales_person_id && 
                                  <div className="display-flex-center flex-wrap mt-1">
                                  <div>
                                    <span className="address-label">{"Contact Number"}</span>
                                    <span className="address-inputfields"> : {values.deliveries[i].sales_person_number}
                                    </span>
                                  </div>
                                  <div className="address-divider">|</div>
                                  <div>
                                    <span className="address-label">{"Email Id"}</span>
                                    <span className="address-inputfields"> : {values.deliveries[i].sales_person_email}
                                    </span>
                                  </div>
                                </div>
                                  }
                              </div>
                          </div>
                        </>
                        {FEATURES.bookingInvoiceDetails ?
                          <>
                            <Divider />

                            <h5 className="card-title">Invoice Details {i + 1}</h5>

                            <>
                              <div className="form-row">
                                <div className="form-group col-4">
                                  <div>
                                    <label>{t("shipment_form.boe_no.title") || "BOE No."}</label>
                                  </div>
                                  <div className="adjust-width-cell">
                                    <Fieldmik disabled={mode == "view" ? true : false} component={MyNormalInput} name={`deliveries[${i}].booking_invoices[${i}].BoE_no`} />
                                  </div>
                                </div>
                                <div className="form-group col-3"></div>
                                <div className="form-group col-4">
                                  <div>
                                    <label>
                                      {t("shipment_form.boe_date.title") || "BOE Date"}
                                    </label>
                                  </div>
                                  <div>
                                    <DateData
                                      disabled={mode == "view" ? true : false}
                                      name={`deliveries[${i}]?.booking_invoices[${i}]?.BoE_date`}
                                      autoComplete="off"
                                      showTimeSelect
                                      timeFormat={DATE_FORMATS.HHmm}
                                      popperClassName="dateTime"
                                      dateFormat={DATE_FORMATS.dd_MM_yyyy_HH_mm}
                                      timeIntervals={5}
                                      customInput={
                                        <Input
                                          icon="time"
                                          className="poupDate"
                                          iconPosition="left"
                                        />
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="form-group col-1"></div>
                              </div>
                            </>
                          </>
                          :
                          null}
                      </div>
                    </div>
                  );
                }))}
              </FieldArray>
            </>
          </>

          <center>
            {mode != "view" ?
              <Button
                type="submit"
                className="m-2"
                primary
                size="mini"
                onClick={handleSubmit}
                disabled={values.disable_submit}
              >
                Submit
              </Button>
              : null}
            <Button
              type="submit"
              className="m-2"
              secondary
              size="mini"
              onClick={() => { routeBackToBookingAggrid() }}
            >
              Cancel
            </Button>
          </center>
        </div>
      </Formiker>
    </div >
  );
};

const FormikShipment = withFormik({
  enableReinitialize: true,
  validationSchema: yup.object().shape({
    route: yup.string().required("required"),
    temp_min: yup.number().optional().nullable()
      .when("temp_max", (temp_max) =>
        temp_max ? yup.number().optional().nullable().max(temp_max, "max") : yup.number().optional().nullable()
      ),
    temp_max: yup.number().optional().nullable()
      .when("temp_min", (temp_min) =>
        temp_min ? yup.number().optional().nullable().min(temp_min, "min") : yup.number().optional().nullable()
      ),
    //container_type_id: yup.string().required("required"),

    deliveries: yup.array().of(
      yup.object().shape({
        billing_party_id: yup.number()
          .when(`FEATURES.billingPartyInBookingsRequired`, {
            is: (value) => { if (FEATURES.billingPartyInBookingsRequired) return true; else return false; },
            then: yup.number().required('required.'),
            otherwise: yup.number().optional().nullable()
          }),
        /* consignor_code: yup.string().required("required"),
        consignee_code: yup.string().required("required"), */
        requested_pickup_date: yup.date(),
        requested_delivery_date: yup.date().min(
          yup.ref('requested_pickup_date'),
          "Delivery Date greater than Pickup Date."
        ),
        /* shipping_line_id: yup.string()
          .when(`localStorage.getItem('customerNumber') == 1327`, {
            is: (value) => { if (!FEATURES.bookingInvoiceDetails) return true; else return false; },
            then: yup.string().required('required'),
            otherwise: yup.string().optional().nullable()
          }),
        yard_id: yup.string().required("required"),
        CHA_id: yup.string().required("required"), */
      },
        [["requested_pickup_date", "requested_delivery_date"]]
      )
    )
  },
    [["temp_max", "temp_min"]]
  ),
  // setFieldValue("required_on", moment().format("DD/MM/yyyy hh:mm"));
  mapPropsToValues: (props) => ({
    disable_submit: false,
    deliveries: [
      (props.mode == 'edit' || props.mode == 'view') ?
        {}
        :
        {
          requested_pickup_date:
            props.bookingRequestObj && props.bookingRequestObj.requested_pickup_date_booking
              ? moment(props.bookingRequestObj.requested_pickup_date_booking, DATE_FORMATS.YYYYMMDD_HHMM)
              : moment(new Date(), DATE_FORMATS.YYYYMMDD_HHMM),
          requested_delivery_date:
            props.bookingRequestObj && props.bookingRequestObj.requested_delivery_date_booking
              ? moment(props.bookingRequestObj.requested_delivery_date_booking, DATE_FORMATS.YYYYMMDD_HHMM)
              : "",
          billing_party_id:
            props.bookingRequestObj && props.bookingRequestObj.billing_party_id
              ? props.bookingRequestObj.billing_party_id
              : null,
          billing_party_placeholder:
            props.bookingRequestObj && props.bookingRequestObj.billing_party_name
              ? props.bookingRequestObj.billing_party_name
              : null,
          billing_party_branch_id:
            props.bookingRequestObj && props.bookingRequestObj.billing_party_branch_id
              ? props.bookingRequestObj.billing_party_branch_id
              : null,
          billing_party_branch_placeholder:
            props.bookingRequestObj &&
              props.bookingRequestObj.billing_party_branch_name
              ? props.bookingRequestObj.billing_party_branch_name
              : null,
          consignor_code:
            props.bookingRequestObj && props.bookingRequestObj.consignor_code
              ? props.bookingRequestObj.consignor_code
              : "",
          consignor_placeholder:
            props.bookingRequestObj && props.bookingRequestObj.consignor
              ? props.bookingRequestObj.consignor.consignor_name
              : "",
          consignee_code:
            props.bookingRequestObj && props.bookingRequestObj.consignee_code
              ? props.bookingRequestObj.consignee_code
              : "",
          consignee_placeholder:
            props.bookingRequestObj && props.bookingRequestObj.consignee
              ? props.bookingRequestObj.consignee.consignee_name
              : "",
          consignorRaw:
            props.bookingRequestObj && props.bookingRequestObj.consignorRaw
              ? props.bookingRequestObj.consignorRaw
              : "",
          consigneeRaw:
            props.bookingRequestObj && props.bookingRequestObj.consigneeRaw
              ? props.bookingRequestObj.consigneeRaw
              : "",
          shipping_line_id:
            props.bookingRequestObj && props.bookingRequestObj.shipping_line_id
              ? props.bookingRequestObj.shipping_line_id
              : null,
          shipping_line_placeholder:
            props.bookingRequestObj && props.bookingRequestObj.shipping_line_name
              ? props.bookingRequestObj.shipping_line_name
              : "",
          CHA_id:
            props.bookingRequestObj && props.bookingRequestObj.CHA_id
              ? props.bookingRequestObj.CHA_id
              : "",
          cha_placeholder:
            props.bookingRequestObj && props.bookingRequestObj.CHA_name
              ? props.bookingRequestObj.CHA_name
              : "",
          yard_id:
            props.bookingRequestObj && props.bookingRequestObj.yard_id
              ? props.bookingRequestObj.yard_id
              : "",
          yard_placeholder:
            props.bookingRequestObj && props.bookingRequestObj.yard_name
              ? props.bookingRequestObj.yard_name
              : "",
          sales_person_id:
              props.bookingRequestObj && props.bookingRequestObj.sales_person_id
                ? props.bookingRequestObj.sales_person_id
                : "",
          booking_invoices: [{
            BoE_no:
              props.bookingRequestObj && props.bookingRequestObj.BoE_no
                ? props.bookingRequestObj.BoE_no
                : null,
            BoE_date:
              props.bookingRequestObj && props.bookingRequestObj.BoE_date
                ? props.bookingRequestObj.BoE_date
                : null,
          }],
        }
    ],
    numberOfDeliveries: props.bookingRequestObj && props.bookingRequestObj.deliveryBooking ? props.bookingRequestObj.deliveryBooking.length : 1,
    route:
      props.bookingRequestObj && props.bookingRequestObj.route
        ? props.bookingRequestObj.route_code
        : "",
    route_placeholder:
      props.bookingRequestObj && props.bookingRequestObj.route
        ? props.bookingRequestObj.route.route_name
        : "",
    number_of_vehicles:
      props.bookingRequestObj && props.bookingRequestObj.no_of_vehicles
        ? props.bookingRequestObj.no_of_vehicles
        : 1,
    show_route_info:
      props.bookingRequestObj && props.bookingRequestObj.route_name
        ? props.bookingRequestObj.route_name
        : "",

    numberOfContainerCount: props.bookingRequestObj && props.bookingRequestObj.booking_containers ? props.bookingRequestObj.booking_containers.length : 1,
    total_number_of_containers: props.bookingRequestObj && props.bookingRequestObj.no_of_vehicles
      ? props.bookingRequestObj.no_of_vehicles
      : 1,
    booking_containers: [
      props.mode == 'edit' ?
        {}
        :
        {
          no_of_containers:
            props.bookingRequestObj && props.bookingRequestObj.no_of_vehicles
              ? props.bookingRequestObj.no_of_vehicles
              : 1,
          container_size:
            props.bookingRequestObj && props.bookingRequestObj.container_size
              ? props.bookingRequestObj.container_size == 'FT20' ? 'FT20' : 'FT40'
              : "FT20",
          container_size_placeholder:
            props.bookingRequestObj && props.bookingRequestObj.container_size
              ? props.bookingRequestObj.container_size == 'FT20' ? '20 Feet' : '40 Feet'
              : "20 Feet",
          container_type_id:
            props.bookingRequestObj && props.bookingRequestObj.container_type_id
              ? props.bookingRequestObj.container_type_id
              : "",
          container_type:
            props.bookingRequestObj && props.bookingRequestObj.container_type
              ? props.bookingRequestObj.container_type
              : "",
        }
    ],
    /* no_of_containers:
      props.bookingRequestObj && props.bookingRequestObj.no_of_vehicles
        ? props.bookingRequestObj.no_of_vehicles
        : 1,
    container_size:
      props.bookingRequestObj && props.bookingRequestObj.container_size
        ? props.bookingRequestObj.container_size == 'FT20' ? 'FT20' : 'FT40'
        : "FT20",
    container_size_placeholder:
      props.bookingRequestObj && props.bookingRequestObj.container_size
        ? props.bookingRequestObj.container_size == 'FT20' ? '20 Feet' : '40 Feet'
        : "20 Feet",
    container_type_id:
      props.bookingRequestObj && props.bookingRequestObj.container_type_id
        ? props.bookingRequestObj.container_type_id
        : "",
    container_type:
      props.bookingRequestObj && props.bookingRequestObj.container_type_id
        ? props.bookingRequestObj.container_type_id
        : "", */
    delivery_order: props.bookingRequestObj && props.bookingRequestObj.delivery_order
      ? props.bookingRequestObj.delivery_order
      : null,
    service_type_id:
      props.bookingRequestObj && props.bookingRequestObj.service_type?.service_type_id != undefined
        ? props.bookingRequestObj.service_type.service_type_id
        : 1,
    service_type_placeholder:
      props.bookingRequestObj && props.bookingRequestObj.service_type?.service_type_name != undefined
        ? props.bookingRequestObj.service_type.service_type_name
        : "FTL",
    load_type:
      props.bookingRequestObj && props.bookingRequestObj.load_type?.load_type_id != undefined
        ? props.bookingRequestObj.load_type.load_type_id
        : 4,
    load_type_placeholder:
      props.bookingRequestObj && props.bookingRequestObj.load_type?.load_type_name != undefined
        ? props.bookingRequestObj.load_type.load_type_name
        : "Dry",
    remarks:
      props.bookingRequestObj && props.bookingRequestObj.remarks
        ? props.bookingRequestObj.remarks
        : "",
    weight:
      props.bookingRequestObj && props.bookingRequestObj.weight
        ? props.bookingRequestObj.weight
        : "",
    vehicle_type:
      props.bookingRequestObj && props.bookingRequestObj.vehicle_type_id
        ? props.bookingRequestObj.vehicle_type_id
        : "",
    vehicle_type_placeholder:
      props.bookingRequestObj && props.bookingRequestObj.vehicle_type_name
        ? props.bookingRequestObj.vehicle_type_name
        : "",
    temp_min:
      props.bookingRequestObj && props.bookingRequestObj.min_temp
        ? props.bookingRequestObj.min_temp
        : "",
    temp_max:
      props.bookingRequestObj && props.bookingRequestObj.max_temp
        ? props.bookingRequestObj.max_temp
        : "",
    DO_no:
      props.bookingRequestObj && props.bookingRequestObj.DO_no
        ? props.bookingRequestObj.DO_no
        : null,
    DO_validity_date:
      props.bookingRequestObj && props.bookingRequestObj.DO_validity_date
        ? moment(props.bookingRequestObj.DO_validity_date, DATE_FORMATS.YYYYMMDD_HHMM)
        : null,
    budgeted_kms:
      props.bookingRequestObj && props.bookingRequestObj.route
        ? props.bookingRequestObj.route.budgeted_kms : "",
    budgeted_time:
      props.bookingRequestObj && props.bookingRequestObj.route
        ? props.bookingRequestObj.route.budgeted_time
        : "",
    shipping_line_id:
      props.bookingRequestObj && props.bookingRequestObj.shipping_line_id
        ? props.bookingRequestObj.shipping_line_id
        : null,
  }),
  handleSubmit(values, { setFieldValue, setSubmitting, props }) {
    setSubmitting(true);
    setFieldValue("disable_submit", true);

    let booking_number = props.booking_number;
    let booking_date = moment(props.requested_pickup_date).format(DATE_FORMATS.YYYYMMDD_HHMM);
    let booking_branch_id = parseInt(props.branch);
    this.handleImportRequest(
      booking_number,
      booking_date,
      booking_branch_id,
      values,
      setFieldValue,
      props
    );
  },
  handleImportRequest(
    booking_number,
    booking_date,
    booking_branch_id,
    values,
    setFieldValue,
    props
  ) {
    let data = {
      ...props?.bookingValues,
      booking_number: booking_number,
      booking_date: moment(props.bookingRequestObj.requested_booking_date).format(DATE_FORMATS.YYYYMMDD_HHMM),
      booking_branch_id: booking_branch_id,
      movement_type: props.movement_type,
      route_code: values.route,
      load_type_id: values.load_type,
      remarks: values.remarks,
      //no_of_vehicles: values.no_of_containers,
      no_of_vehicles: values.total_number_of_containers,
      booking_containers: values.booking_containers,
      //container_size: values.container_size,
      //container_type_id: values.container_type_id,
      weight: parseInt(values.weight),
      min_temp: parseInt(values.temp_min),
      max_temp: parseInt(values.temp_max),
      service_type_id: values.service_type_id,
      budgeted_time: this.ParseFloat(values.budgeted_time, 2),
      budgeted_kms: this.ParseFloat(values.budgeted_kms, 2),
      booking_deliveries: values.deliveries,
    };
    if(FEATURES.creditCheckRequired && !data.expected_billing_amount){
      setFieldValue("disable_submit", false);
      cogoToast.error(TOAST_MESSAGES.FIELD_REQUIRED("Expected Billing Amount"))
      return;
    }

    for (let index = 0; index < data.booking_deliveries.length; index++) {
      data.booking_deliveries[index].requested_pickup_date = moment(data.booking_deliveries[index].requested_pickup_date).format(DATE_FORMATS.YYYYMMDD_HHMM);
      data.booking_deliveries[index].requested_delivery_date = moment(data.booking_deliveries[index].requested_delivery_date).format(DATE_FORMATS.YYYYMMDD_HHMM);

      //data.booking_deliveries[index].container_size = values.container_size;
      //data.booking_deliveries[index].container_type_id = values.container_type_id;
      data.booking_deliveries[index].DO_no = values.DO_no;
      data.booking_deliveries[index].DO_validity_date = values.DO_validity_date;
    }

    if (props.mode == "edit") {
      data.budgeted_time = this.ParseFloat(values.budgeted_time, 2);
      data.budgeted_kms = this.ParseFloat(values.budgeted_kms, 2);

      for (let index = 0; index < data.booking_deliveries.length; index++) {
        data.booking_deliveries[index].booking_delivery_id = props.bookingRequestObj.booking_deliveries[index].booking_delivery_id;
        if (values?.deliveries?.[index]?.booking_invoices) {
          for (let jindex = 0; jindex < values.deliveries[index].booking_invoices.length; jindex++) {
            data.booking_deliveries[index].booking_invoices[jindex].booking_invoice_id = props.bookingRequestObj.booking_deliveries[index].booking_invoices[jindex].booking_invoice_id;
          }
        }
      }
    } else {
      data.budgeted_time = this.ParseFloat(values.budgeted_time, 2);
      data.budgeted_kms = this.ParseFloat(values.budgeted_kms, 2);
    }

    let requestData = {};
    if (props.mode == "edit") {
      let bookingID = props.bookingRequestObj.booking_id;
      requestData.requestFormat = {
        url: `/bookings/${bookingID}`,
        method: "PATCH",
        Items: data,
      };
    } else {
      requestData.requestFormat = {
        url: "/bookings",
        method: "post",
        Items: data,
      };
    }
    if (booking_branch_id) {
      this.requestToAPI(requestData, props, setFieldValue);
    } else {
      setFieldValue("disable_submit", false);
      cogoToast.error("Booking Branch is Required")
    }
  },
  ParseFloat(str, val) {
    str = str.toString();
    if (str.indexOf(".") > 1)
      str = str.slice(0, str.indexOf(".") + val + 1);
    let convertValue = parseFloat(str).toFixed(2) * 1.00;
    return (convertValue);
  },
  requestToAPI(requestData, props, setFieldValue) {
    let request = requestData.requestFormat;

    allAxiosCommonTA({
      url: request.url,
      method: request.method,
      Items: request.Items,
    })
      .then((response) => {
        if (response.message) cogoToast.success(response.message);
        else cogoToast.success("Booking updated Successfully!!");

        props.routeBackToListing();
      })
      .catch((err) => {
        setFieldValue("disable_submit", false);
        if (err.data && (err.data.error || err.data.message)) {
          if (err.data.message) {
            cogoToast.success(err.data.message);
            if (err.data.message == "Booking created successfully.") {
              props.routeBackToListing();
            }
          } else {
            cogoToast.error(err.data.error);
          }
        }else if(err?.response?.data?.message) cogoToast.error(err?.response?.data?.message);
         else cogoToast.error("Error while creating booking.");
      });
  },
})(insertBookingRequestImportEdit);

const mapStateToProps = ({ shipment }) => {
  return {
    shipment,
  };
};

export default connect(mapStateToProps, {
  createShipmentDispatcher,
  successAlertDispatcher,
  errorAlertDispatcher,
  deleteAllOrderDispatcher,
})(translate("create_booking_request")(FormikShipment));
